<template>
  <v-layout align-center row v-if="!multiple">
    <v-tooltip bottom v-for="action in Actions" :key="action.value" style="margin: 0px;">
      <template slot="activator">
        <v-btn :color="Color" icon flat @click="bus.$emit(action.event,model)"
          style="margin: 0px;width: 24px;height: 24px;">
          <v-icon style="margin: 0px;" small>{{action.icon}}</v-icon>
        </v-btn>
      </template>
      <span>{{action.text}}</span>
    </v-tooltip>

  </v-layout>
</template>

<style scoped>

</style>

<script>
  import CellSort from "./cellSort.ts";
  export default CellSort;
</script>